import { Link } from "react-router-dom";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";
import { Reveal } from "./motion-primitives";
import { useSeo } from "./useSeo";

const CONTENT = {
  privacy: {
    label: "Privacy",
    title: "Privacy Policy",
    seo: { title: "Privacy — Holideviser", description: "Holideviser privacy information." },
  },
  terms: {
    label: "Terms",
    title: "Terms of Service",
    seo: { title: "Terms — Holideviser", description: "Holideviser terms of service." },
  },
};

// Honest temporary state until founder-approved policy content is supplied (production-release blocker).
export const PolicyPage = ({ kind }) => {
  const c = CONTENT[kind];
  useSeo(c.seo);

  return (
    <div className="min-h-screen bg-ink text-cream" data-testid={`policy-page-${kind}`}>
      <Navigation />
      <main className="mx-auto max-w-[900px] px-6 pb-24 pt-40 sm:px-10 lg:pt-52">
        <Reveal>
          <div className="mb-6 flex items-center gap-4">
            <span className="h-px w-10 bg-teal" />
            <span className="font-sans text-xs uppercase tracking-[0.3em] text-teal">{c.label}</span>
          </div>
        </Reveal>
        <Reveal delay={0.06}>
          <h1 className="font-serif text-5xl font-light leading-[1.03] tracking-tight text-cream sm:text-6xl">
            {c.title}
          </h1>
        </Reveal>
        <Reveal delay={0.12}>
          <p
            data-testid="policy-finalizing-note"
            className="mt-8 max-w-xl font-sans text-base leading-relaxed text-sand sm:text-lg"
          >
            Policy information is being finalized.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <Link
            to="/"
            className="mt-10 inline-flex items-center gap-2 border-b border-teal pb-1 font-sans text-xs uppercase tracking-[0.18em] text-cream transition-colors hover:text-teal"
          >
            Back to home
          </Link>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
};
